import React from 'react'
import { useHistory } from 'react-router'
import { ClipboardTick } from 'iconsax-react'
import { useTheme } from '@mui/material'

import { useTaskAPI } from '@SonarCX/providers/TaskAPIProvider'
import { Routes } from '@SonarCX/Routes'
import { FavoriteCardProps } from '..'

import FavoriteButton from '@SonarCX/components/atoms/FavoriteButton'
import Tooltip from '@SonarCX/components/atoms/Tooltip'

import useStyles from '../styles'
import DraggableContainer from '../DraggableContainer'

const FavoriteTask: React.FC<FavoriteCardProps> = ({
  favorite,
  searchValue,
  draggable,
  handleMoveFavorite
}) => {
  const theme = useTheme()
  const classes = useStyles({})
  const history = useHistory()
  const { tasks: allTasks, loaded: tasksLoaded, loadTask } = useTaskAPI()
  const fullTask = React.useMemo(
    () => allTasks[favorite.item_id] ?? null,
    [allTasks, favorite]
  )
  const navigate = () => {
    history.push(`${Routes.TASKS}/${favorite.item_id}`)
  }
  // Gets the full tasks
  React.useEffect(() => {
    if (!tasksLoaded || fullTask) {
      return
    }
    loadTask(favorite.item_id)
  }, [tasksLoaded, allTasks, loadTask, favorite, fullTask])

  if (!fullTask) return null

  if (
    searchValue.length > 0 &&
    !fullTask.title.toLowerCase().includes(searchValue.toLowerCase())
  )
    return null

  return (
    <DraggableContainer
      favorite={favorite}
      draggable={draggable}
      handleMoveFavorite={handleMoveFavorite}
    >
      <div onClick={navigate}>
        <span className={classes.info}>
          <FavoriteButton
            isFavorite
            type={favorite.type}
            itemId={favorite.item_id}
          />

          <Tooltip title='Task'>
            <ClipboardTick
              size={theme.size.base}
              variant='Bulk'
              color={theme.palette.primary.main}
            />
          </Tooltip>
          <span className={classes.title}>{fullTask.title}</span>
        </span>
      </div>
    </DraggableContainer>
  )
}

export default FavoriteTask
